import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Box, Container, Stack, Typography } from '@thirdspacelearning/library';

import { useKeycloakAuth } from '@tsl-frontend/tsl-keycloak-auth';

import { SessionPanels, BadgesPanel, LOsPanel } from '@features/dashboard';

import {
    currentProgrammeSelector,
    userWelcomeRequiredSelector,
} from '@store/programme';
import { Footer } from '@shared';
import { RoutePaths } from '@routes';
import DashboardDecoration from '@assets/dashboard/DashboardDecoration';

const Dashboard = () => {
    const navigate = useNavigate();
    const { user } = useKeycloakAuth();

    const currentProgramme = useSelector(currentProgrammeSelector);
    const isWelcomeRequired = useSelector(userWelcomeRequiredSelector);

    useEffect(() => {
        if (isWelcomeRequired) {
            navigate(RoutePaths.WELCOME);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Container maxWidth="lg">
            <Stack gap={2} height="100%">
                <Typography
                    data-testid="welcomeText"
                    variant="h5"
                    fontWeight="bold"
                    sx={{ mb: 2 }}
                >
                    {user?.first_name}'s home
                </Typography>

                <SessionPanels />

                {!currentProgramme && (
                    <Stack>
                        <DashboardDecoration />
                    </Stack>
                )}

                <BadgesPanel />

                <LOsPanel />

                <Box display="flex" flexGrow={1} alignItems="flex-end">
                    <Footer />
                </Box>
            </Stack>
        </Container>
    );
};

export default Dashboard;
